<template>
    <div class="stay" v-cloak>
        <div class="stay__wrapper" :class="[{ 'active' : mapView }, { 'index' : filtersActive }]">
            <product-filters @togglemap="mapView = !mapView" @toggleopen="toggleFilters" @clearfilters="clearFilters"
                             v-model="model" :empty="filtersEmpty"
                             :total="total" :show-map="pins.length > 0" :product="product"
                             :buttons="buttons" :dates="dates">
            </product-filters>
            <div class="stay__location" v-if="pins.length > 0">
                <product-map :pins="pins"></product-map>
            </div>
        </div>
        <div class="stay__body">
            <div class="stay__container container">
                <h1 class="stay__title title title_big">
                    <slot name="title"></slot>
                </h1>
                <slot class="something" name="intro"></slot>
                <ul class="stay__list">
                    <product-item v-if="!loading" v-for="item in curPage" :model="item" :key="item.Id"></product-item>
                    <skeleton v-for="i in params.perPage" :key="'skeleton_' + i" v-if="loading"></skeleton>
                </ul>
                <p class="text-center mt-5" v-if="results.length == 0">Nothing matched your search</p>
                <ul class="pagination" v-if="pages > 1">
                    <li class="pointer" v-if="params.page > 0"><a class="pagination__prev" @click="setPage(params.page-1)"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="13" viewBox="0 0 36 13"><g transform="matrix(-1 0 0 -1 35.5 12.5)" fill="#009dbb"><path d="M35 6.5H0A.5.5 0 0 1-.5 6a.5.5 0 0 1 .5-.5h35a.5.5 0 1 1 0 1z" /><path d="M35 6.5a.5.5 0 0 1-.354-.146l-6-6a.5.5 0 0 1 0-.707.5.5 0 0 1 .707 0l6 6A.5.5 0 0 1 35 6.5z" /><path d="M29 12.5a.5.5 0 0 1-.354-.853l6-6a.5.5 0 0 1 .707.707l-6 6A.5.5 0 0 1 29 12.5z" /></g></svg></a></li>
                    <li class="pointer" v-if="params.page > 0" @click="setPage(params.page-1)"><a>{{displayPage-1}}</a></li>
                    <li class="pointer"><a class="active">{{displayPage}}</a></li>
                    <li class="pointer" v-if="params.page < pages-1" @click="setPage(params.page+1)"><a>{{displayPage+1}}</a></li>
                    <li class="pointer" v-if="params.page < pages-1"><a class="pagination__next" @click="setPage(params.page+1)"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="13" fill="#009dbb" viewBox="0 0 36 13"><path d="M35.5 7H.5a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h35a.5.5 0 1 1 0 1z" /><path d="M35.5 7a.5.5 0 0 1-.354-.146l-6-6a.5.5 0 0 1 0-.707.5.5 0 0 1 .707 0l6 6A.5.5 0 0 1 35.5 7z" /><path d="M29.5 13a.5.5 0 0 1-.354-.853l6-6a.5.5 0 0 1 .707.707l-6 6A.5.5 0 0 1 29.5 13z" /></svg></a></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import productFilters from './productFilters'
    import productMap from './productMap'
    import productItem from './productItem'
    import skeleton from './skeleton'

    export default {
        components: {
            productFilters,
            productMap,
            productItem,
            skeleton
        },
        props: {
            dates: Boolean,
            product: String,
            buttons: Array
        },
        data() {
            return {
                model: {
                    island: [],
                    type: [],
                    category: [],
                    rating: [],
                    facility: [],
                    busroute: [],
                    departurepoint: [],
                    theme: [],
                    dates: { from: null, to: null },
                },
                params: {
                    page: 0,
                    perPage: 18,
                    timestamp: new Date()
                },
                mapView: false,
                total: 0,
                results: [],
                filtersActive: false,
                scrollTop: 0,
                hasMounted: false,
                loading: false
            }
        },
        computed: {
            pins() {
                return this.results.filter(r => !r.Point.IsNull)
            },
            displayPage() {
                return this.params.page + 1
            },
            pages() {
                return Math.ceil(this.results.length / this.params.perPage)
            },
            curPage() {
                return this.results.slice(this.params.page * this.params.perPage, (this.params.page * this.params.perPage) + this.params.perPage)
            },
            filtersEmpty() {
                return this.model.island.length == 0 && this.model.type.length == 0
                    && this.model.category.length == 0 && this.model.rating.length == 0
                    && this.model.facility.length == 0 && this.model.busroute.length == 0
                    && this.model.departurepoint.length == 0 && this.model.theme.length == 0
                    && this.model.dates.from == null && this.model.dates.to == null
            }
        },
        methods: {
            clearFilters() {
                window.localStorage.removeItem(this.product + '_filters')
                window.localStorage.removeItem(this.product + '_params')
                window.location.href = window.location.href.replace(window.location.search, '')
            },
            toggleFilters(on) {
                this.filtersActive = on
            },
            setPage(p) {
                this.params.page = p
                this.storeState()
                this.doScroll()
            },
            doSearch() {
                var vm = this
                vm.loading = true
                vm.params.timestamp = new Date()
                vm.storeState()
                vm.doPost('/umbraco/surface/product/' + vm.product, {
                    islandIds: vm.model.island, typeIds: vm.model.type,
                    ratings: vm.model.rating, facilityIds: vm.model.facility,
                    busrouteIds: vm.model.busroute, categoryIds: vm.model.category,
                    departurePointIds: vm.model.departurepoint, curationIds: vm.model.theme,
                    fromDate: vm.model.dates.from, toDate: vm.model.dates.to
                }, (data) => {
                    vm.results = data
                    vm.total = vm.results.length
                    vm.hasMounted = true
                    if (vm.mapView && vm.pins.length == 0) vm.mapView = false
                    vm.loading = false
                })
            },
            storeState() {
                window.localStorage.setItem(this.product + '_params', JSON.stringify(this.params))
                window.localStorage.setItem(this.product + '_filters', JSON.stringify(this.model))
            },
            doScroll() {
                var vm = this
                window.scrollTo({
                    top: vm.scrollTop,
                    behavior: 'smooth'
                })
            },
        },
        watch: {
            model: {
                deep: true,
                handler() {
                    if (this.hasMounted) {
                        window.history.replaceState('', '', window.location.href.replace(window.location.search, ''))
                        this.params.page = 0
                        this.doSearch()
                        this.doScroll()
                    }
                }
            }
        },
        updated() {
            window.lazyLoad.update()
        },
        mounted() {
            var vm = this
            vm.scrollTop = vm.$el.querySelector('.stay__list').offsetTop - 30
            if (vm.querystringObject.type) vm.model['type'].push(...vm.getIds(vm.querystringObject.type))
            if (vm.querystringObject.category) vm.model['category'].push(...vm.getIds(vm.querystringObject.category))
            if (vm.querystringObject.island) vm.model['island'].push(...vm.getIds(vm.querystringObject.island))
            if (vm.querystringObject.facility) vm.model['facility'].push(...vm.getIds(vm.querystringObject.facility))
            if (vm.querystringObject.rating) vm.model['rating'].push(...vm.getIds(vm.querystringObject.rating))
            if (vm.querystringObject.busroute) vm.model['busroute'].push(...vm.getIds(vm.querystringObject.busroute))
            if (vm.querystringObject.departurepoint) vm.model['departurepoint'].push(...vm.getIds(vm.querystringObject.departurepoint))
            if (vm.querystringObject.theme) vm.model['theme'].push(...vm.getIds(vm.querystringObject.theme))
            if (vm.filtersEmpty) {
                var params = window.localStorage.getItem(vm.product + '_params')
                if (params != null) {
                    vm.params = JSON.parse(params)
                    vm.params.timestamp = new Date(vm.params.timestamp)
                    var since = new Date() - vm.params.timestamp
                    if (since < (1000 * 60 * 10)) {
                        var stored = window.localStorage.getItem(vm.product + '_filters')
                        if (stored != null) vm.model = JSON.parse(stored)
                    }
                }
            }
            vm.doSearch()
        }
    }
</script>